import NFCeConfig from "./config"
import List from "./"
import BatchNFCe from "./BatchNFCe"

export const paths = [
    {
        path: '/nfce/settings',
        component: NFCeConfig
    },
    {
        path: '/nfce/list',
        component: List
    },
    {
        path: '/nfce/batch',
        component: BatchNFCe
    }
]
export const NFCeRouters = {
    icon: "receipt",
    testId: '',
    path: "/nfce/settings",
    label: "NFC-e",
    tree: [
        {
            testId: '',
            icon: 'list',
            path: '/nfce/list',
            label: "Notas Emitidas"
        },
        {
            icon: "cog",
            testId: '',
            path: "/nfce/settings",
            label: "Configurações"
        },
        {
            icon: "file-export",
            testId: '',
            path: "/nfce/batch",
            label: "Exportar XML em lote"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFCe/routers.js